var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95459 3.61035H5.95459V2.61035H4.95459M5.45459 9.11035C3.24959 9.11035 1.45459 7.31535 1.45459 5.11035C1.45459 2.90535 3.24959 1.11035 5.45459 1.11035C7.65959 1.11035 9.45459 2.90535 9.45459 5.11035C9.45459 7.31535 7.65959 9.11035 5.45459 9.11035ZM5.45459 0.110352C4.79798 0.110352 4.1478 0.23968 3.54117 0.490954C2.93454 0.742227 2.38335 1.11052 1.91906 1.57482C0.981374 2.5125 0.45459 3.78427 0.45459 5.11035C0.45459 6.43643 0.981374 7.7082 1.91906 8.64589C2.38335 9.11018 2.93454 9.47848 3.54117 9.72975C4.1478 9.98102 4.79798 10.1104 5.45459 10.1104C6.78067 10.1104 8.05244 9.58357 8.99012 8.64589C9.92781 7.7082 10.4546 6.43643 10.4546 5.11035C10.4546 4.45374 10.3253 3.80356 10.074 3.19693C9.82271 2.59031 9.45442 2.03911 8.99012 1.57482C8.52583 1.11052 7.97464 0.742227 7.36801 0.490954C6.76138 0.23968 6.1112 0.110352 5.45459 0.110352ZM4.95459 7.61035H5.95459V4.61035H4.95459V7.61035Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.37bc92dc66ddfd4d996eeb5a4af777e2.svg";
export { ForwardRef as ReactComponent };